var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.get('cart/cartAutoRemovals'))?_c('div',{staticClass:"my-1"},[_c('span',{staticClass:"pointer pa-1 rounded warning font-0",on:{"click":_vm.showAutoRemovalsModal}},[_vm._v("Hubo cambios en tu carrito")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }